export default __webpack_public_path__ + "static/media/main-app-blue.bbe3634f.png";